import { Modal } from "react-bootstrap"
import AppModal from "../../Common/AppModal"
import { Character } from "../../../types"
import { baseURL, socket } from "../../../api"
import { DialogueMessage, Monster } from "../../../types/LogicTypes"
import { useDispatch } from "react-redux"
import { openWindow } from "../../../actions"
import CharThumbnail from "./CharThumbnail"
import MonsterThumbnail from "./MonsterThumbnail"
import { useEffect, useState } from "react"
import { getGameDataForCombat } from "../helpers/dataHelpers"
import { expGameInstance } from "../ThreeTestFC"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSkull } from "@fortawesome/free-solid-svg-icons"

type Props = {
    character: Character
}
const Combat: React.FC<Props> = (props) => {
    const dispatch: any = useDispatch();
    const [monster, setMonster] = useState<Monster | undefined>()

    useEffect(() => {
        if (expGameInstance) {
            const d = getGameDataForCombat(expGameInstance, props.character)
            if (d) {
                setMonster(d.monster)
            } else {
                monster && setMonster({...monster, health: 0})
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.character]);

    const DiagItem = (d: DialogueMessage, i: number): React.ReactNode => {
        if (d.type === "message") {
            return <div key={i} className={`p-2 message ${d.subType ?? ""}`}>
                {d.subType === "monster" && <FontAwesomeIcon icon={faSkull} className="me-2 text-orange" />}
                {d.message}
            </div>
        }
        return <></>
    }

    const attemptToFlee = () => {
        socket.emit("attemptToFlee")
    }

    const attackR = () => {
        socket.emit("attackR")
    }

    const attackL = () => {
        socket.emit("attackL")
    }

    const openInventory = () => {
        dispatch(openWindow("inventory"))
    }

    const rHandItem = props.character.equipped.find(e => e.loca === "rhand")?.item
    const lHandItem = props.character.equipped.find(e => e.loca === "lhand")?.item

    return (
        <AppModal name="combat" title={props.character.combatStatus.title ?? ""} preventClosing>
            <Modal.Body className="p-2">
                <CharThumbnail character={props.character} displayHS />
                <div style={{position: "absolute", right: "8px", top: "8px"}}>
                    {monster && <MonsterThumbnail monster={monster} />}
                </div>
                { props.character.combatStatus.messages.slice(Math.max(props.character.combatStatus.messages.length - 5, 0)).map((m, i) => DiagItem(m, i)) }

            </Modal.Body>
            <Modal.Footer className="p-1" style={{justifyContent: "center"}}>
                <div className="toolbar" style={{lineHeight: "0", opacity: props.character.combatStatus.isYourTurn ? "1": ".5"}}>
                    <div className="button" onClick={attackR} style={{backgroundImage: "url(img/ui/sq_btn_01.png)", display: "inline-block"}}>
                        { (rHandItem && rHandItem.categories.includes("weapon")) &&
                            <img src={`${baseURL}/${rHandItem.img}`} alt="" />
                        }
                    </div>
                    <div className="button me-4" onClick={attackL} style={{backgroundImage: "url(img/ui/sq_btn_01.png)", display: "inline-block"}}>
                        { (lHandItem && lHandItem.categories.includes("weapon")) &&
                            <img src={`${baseURL}/${lHandItem.img}`} alt="" />
                        }
                    </div>

                    <div className="button" onClick={openInventory} style={{backgroundImage: "url(img/ui/sq_btn_01.png)", display: "inline-block"}}>
                        <img src={`${baseURL}/img/assets/items/backpack_01.png`} alt="" />
                    </div>
                    <div className="button" onClick={attemptToFlee} style={{backgroundImage: "url(img/ui/sq_btn_01.png)", display: "inline-block"}}>
                        <img src={`${baseURL}/img/assets/ui/icon_run_01.png`} alt="" />
                    </div>
                </div>
            </Modal.Footer>
        </AppModal>
    )
}
export default Combat